export const multipleRunDisabledError = {
  title: 'У вас уже есть запущенная рассылка «Брошенная корзина»',
  body:
    'Одновременно запустить две рассылки одного типа не получится. Вы можете остановить предыдущую и запустить эту.',
};
